import { booleanAttribute, Component, input } from '@angular/core';

/**
 * The mono caption in capitals above a heading or beside a status. `mark` prefixes the
 * bronze square; `size` is `md` (11px) for section eyebrows and `sm` (10px) for meta rows
 * and fieldset titles.
 */
@Component({
  selector: 'span[ppcEyebrow], div[ppcEyebrow]',
  template: '<ng-content />',
  styleUrl: './eyebrow.css',
  host: {
    '[attr.data-mark]': 'mark() || null',
    '[attr.data-size]': 'size()',
  },
})
export class PpcEyebrow {

  readonly mark = input(false, { transform: booleanAttribute });
  readonly size = input<'sm' | 'md'>('md');

}
